import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { onlyNumber, rem } from "assets/js/common";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getCryptoPwd, displayTel, displayBirth } from "assets/js/common";
import { useForm } from "react-hook-form";
import { loadAction } from "redux/reducers/top";
import { useHistory } from "react-router-dom";
import DrawerComplete from "components/ui/drawer-complete";

const useStyles = makeStyles((theme) => ({
  point: {
    "& .border-top": {
      borderTop: "1px solid #eee",
      padding: 0,
    },
    "& .layout-flex1": {
      padding: `${rem(40)} ${rem(30)}`,
      height: "auto",
      flex: 1,
      "& .layout-footer": {
        marginTop: "auto",
      },
    },
  },
}));

export default function PointPassword(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showPwd, setShowPwd] = useState({
    pwd: false,
  });

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    trigger,
    formState: { errors, submitCount },
  } = useForm({
    defaultValue: {
      pwd: "",
    },
  });

  watch("pwd", false);

  const loadData = async () => {
    const { data } = await axios.get("/api/mb/mypage");
    setValue("pwd", data.data.cashRctNo);
  };

  const onSubmit = async (data) => {
    const pwd = {
      cashRctNo: data.pwd,
    };
    if (data.pwd) {
      await axios.post(`api/mb/mypage/modify-cash-receipt`, pwd).then((res) => {
        setOpen(true);
      });
    }
  };

  useEffect(() => {
    dispatch(
      loadAction({ back: true, title: "현금영수증 번호 등록", menu: false })
    );
    loadData();
  }, []);

  const [open, setOpen] = useState(false);
  window.appBackKeyHandle = () => {
    history.goBack();
  };

  return (
    <main id="main" className={"container nopad " + classes.point}>
      <div className="receipt-select bg-grey">
        <dl>
          <dt>현명한 소비를 위한 첫걸음!</dt>
          <dd>
            현금영수증 번호 등록하시고
            <br />
            편리하게 현금영수증 발급받으세요.
          </dd>
        </dl>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="layout-flex1">
        <div className="layout-body join-body">
          <Grid container spacing={1} className="form-group-wrap" mt={9}>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined">
                <InputLabel shrink>현금영수증 번호 입력</InputLabel>
                <OutlinedInput
                  id="pwd"
                  inputProps={{
                    maxLength: 11,
                  }}
                  type="tel"
                  placeholder="'-'를 제외하고 입력"
                  aria-describedby="error-pw"
                  {...register("pwd", {
                    pattern: /(^01.{1})([0-9]{3,4})([0-9]{4})/g,
                  })}
                />
                {/* {(errors.pwd?.type === "minLength" ||
                  errors.pwd?.type === "maxLength") && (
                  <FormHelperText id="error-pw" className="error">
                    숫자 11자리를 입력해주세요.
                  </FormHelperText>
                )} */}
                {errors.pwd?.type === "pattern" && (
                  <FormHelperText id="error-pw" className="error">
                    잘못된 전화번호입니다. 다시 확인해주세요.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </div>

        <div className="layout-footer">
          <div className="layout-link">
            <Button variant="contained" color="primary" type="submit">
              입력 완료
            </Button>
          </div>
        </div>
      </form>
      <Box className="notice is-bottom border-top">
        <p className="title">
          <i className="ico-noti" />
          유의사항
        </p>
        <ul className="list list-dot color-info font-14">
          <li>
            휴대전화번호가 변경된 경우 반드시 현금영수증 번호를 변경해주세요
          </li>
        </ul>
      </Box>

      <DrawerComplete
        open={open}
        handleDrawerClose={() => history.goBack()}
        text={`현금영수증 번호가 등록되었습니다.`}
        callback={() => {}}
      />
    </main>
  );
}
